import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatIsoDateTime } from '../util/formatters';
const actorLabel = (createdBy) => {
    if (createdBy === 'system') {
        return 'system';
    }
    // Future: map Cognito sub -> email via a lookup. For now show the raw value.
    return createdBy === 'operator' ? 'operator' : createdBy;
};
const buildEntriesFromVersions = (versions) => versions.map(v => ({
    at: v.createdAt,
    actor: actorLabel(v.createdBy),
    event: v.version === 1
        ? 'Defense document generated (v1)'
        : `Defense document regenerated (v${v.version})`,
    note: v.operatorNote
}));
const buildReviewEntries = (caseData) => {
    const entries = [];
    if (caseData.reviewDecision && caseData.reviewedAt) {
        entries.push({
            at: caseData.reviewedAt,
            actor: 'operator',
            event: `Defense document ${caseData.reviewDecision.toLowerCase()}`,
            note: caseData.reviewerNote
        });
    }
    if (caseData.submittedAt) {
        entries.push({
            at: caseData.submittedAt,
            actor: 'system',
            event: caseData.submittedReasonCode
                ? `Submitted to Adyen (reason ${caseData.submittedReasonCode})`
                : 'Submitted to Adyen'
        });
    }
    return entries;
};
const sortEntries = (entries) => [...entries].sort((a, b) => (a.at < b.at ? 1 : -1));
export const ActivityTimeline = ({ caseData }) => {
    const entries = sortEntries([
        ...buildEntriesFromVersions(caseData.defenseDocumentVersions ?? []),
        ...buildReviewEntries(caseData)
    ]);
    if (entries.length === 0) {
        return null;
    }
    return (_jsxs("section", { className: "space-y-2", children: [_jsx("h2", { className: "text-lg font-semibold", children: "Activity" }), _jsx("ul", { className: "text-sm space-y-2", children: entries.map((e, i) => (_jsxs("li", { className: "border-l-2 border-base-300 pl-3", children: [_jsxs("div", { className: "flex justify-between gap-3 flex-wrap", children: [_jsx("span", { children: e.event }), _jsxs("span", { className: "opacity-70 text-xs", children: [formatIsoDateTime(e.at), " \u00B7 ", e.actor] })] }), e.note ? (_jsxs("p", { className: "text-xs opacity-70 italic mt-1", children: ["\u201C", e.note, "\u201D"] })) : null] }, i))) })] }));
};
